import { render, staticRenderFns } from "./quotationItem.vue?vue&type=template&id=c3878804&"
import script from "./quotationItem.vue?vue&type=script&lang=js&"
export * from "./quotationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports